import { render, staticRenderFns } from "./RenewalMessageList.vue?vue&type=template&id=3d2e6920&"
import script from "./RenewalMessageList.vue?vue&type=script&lang=js&"
export * from "./RenewalMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports